import { Pipe, PipeTransform } from '@angular/core';
import { FileMetadata, CommonDimensions } from 'src/app/models/collection.interface';

@Pipe({
  name: 'catalogueValue',
  pure: true,
  standalone: true
})
export class CatalogueValuePipe implements PipeTransform {
  transform(file: FileMetadata, key: keyof CommonDimensions | string): string {
    if (file?.catalogue?.[key]) {
      return file.catalogue[key] || 'N/A';
    }
    return 'N/A';
  }
}
